import AccessoryCommon from "./accessoryCommon";
import {Shower} from "../../parts/shower";
import {ShowerTubCombo} from "../../parts/showerTubCombo";
import {createParentPositions} from "../../constants";

export default class SeatPad extends AccessoryCommon {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'seat_pad';
    this.partName = 'Seat Pad';
    this.translateId = "visualizer.bathroom.accessories.seat_pad";
    this.visible = true;
    this.canBeDisabled = true;
    if (isChild) {
      createParentPositions(this);
    }
  }


  navigationSubItems(filters, searchText) {
    return this.navigationSubItemsWithSides(filters, searchText);
  }

  disabledClick() {
    Object.keys(this.layerPositions).forEach(position => {
      if (this.layerPositions[position] && this.layerPositions[position].metaData["layerPosition"]) {
        this.checkRelatedFeatureGroupPositions(this.layerPositions[position].metaData["layerPosition"]);
      }
    })
  }

  handleClick() { // "this" is feature!! not the feature group
    super.handleClick();
    const parent = this.getParent();
    const showerComboParent = parent.getParent().layout.parts[ShowerTubCombo.id]
    if (showerComboParent.showerTubComboIsActive) {
      showerComboParent.showerTubComboIsActive = false;
    }
    parent.checkRelatedFeatureGroupPositions(this.metaData["layerPosition"]);
  }

  hideLayerCondition() {
    const showerParent = this.getParent().layout.parts[Shower.id];
    const showerAccParent = this.getParent();
    if (showerParent?.showerTubComboIsActive()) {//  shower tub combo - remove
      return true
    }
    return !showerAccParent || !showerAccParent.seats || showerAccParent.seats.disabled
  }

  // getActiveFeatureConditions(forFeature) {
  //   let conditions = this.getArrayOfConditions();
  //   if (forFeature?.dbFeature?.sharedFeatureName) {
  //     conditions = conditions.map(condition => {
  //       if (condition.propName === "MatchingFeature") {
  //         condition.propValue = forFeature.dbFeature.sharedFeatureName
  //       }
  //       return condition
  //     })
  //   }
  //   return conditions;
  // }
  //
  // layerPositionCantBeApplied = (position, testFeature) => {
  //   const showerAccParent = this.getParent();
  //   return !showerAccParent.seats || !showerAccParent.seats.layerPositions || !showerAccParent.seats.layerPositions[position]
  //     || !testFeature.matchesMetaForArrayOfConditions(this.getActiveFeatureConditions(showerAccParent.seats.layerPositions[position]))
  // }

  checkRenderLayersPositions() {
    const showerAccParent = this.getParent();
    if (showerAccParent.seats?.layerPositions && this.layerPositions && this.activeFeature) {
      Object.keys(showerAccParent.seats.layerPositions).forEach(position => {
        if (this.layerPositions[position] && !showerAccParent.seats
          || !showerAccParent.seats.layerPositions || !showerAccParent.seats.layerPositions[position]) {
          this.layerPositions[position] = null
        }
        // if (!this.layerPositions[position] && showerAccParent.seats.layerPositions[position]) {
        //   this.layerPositions[position] = this.getMatchingPositionFeature(position)
        // } else if (this.layerPositions[position] && !showerAccParent.seats.layerPositions[position]) {
        //   const {wizardActiveItem} = store.getState().wizardState;
        //   if (!wizardActiveItem || !wizardActiveItem.hideItems) {
        //     this.layerPositions[position] = null
        //   }
        // }
      })
    }
  }

  setLayers(layout) {
    if (this.hideLayerCondition()) {
      super.hideLayers();
      return;
    }
    this.checkRenderLayersPositions();
    return super.setLayers(layout);
  }

}
